var _templateObject;
var _excluded = ["text", "children", "iconProps", "textProps"],
  _excluded2 = ["args", "text", "leftIcon", "rightIcon", "onClick", "children"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useCallback, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/styles';
import { Box, Grid, IconButton, Menu, MenuItem, Typography, styled, Icon } from '@mui/material';

/**
 * Provides abstraction for dropdown menus.
 *
 * Does not provide functionality for nested dropdown menus. If recursive menus are required, see `NestedMenu`.
 *
 * @param text: `String` that will represent the label of the dropdown button.
 * @param args: Any arguments that should be passed through to inner MUI `Menu` component.
 * @returns {JSX.element}
 */
var BrandDropdown = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var text = _ref.text,
    children = _ref.children,
    iconProps = _ref.iconProps,
    textProps = _ref.textProps,
    args = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var isOpen = Boolean(anchorEl);
  var handleClick = useCallback(function (e) {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  }, [setAnchorEl]);
  var handleClose = useCallback(function (e) {
    e.preventDefault();
    setAnchorEl(null);
  }, [setAnchorEl]);
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    sx: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClick,
    size: "small",
    sx: {
      ml: 2,
      borderRadius: '5px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: (textProps === null || textProps === void 0 ? void 0 : textProps.color) || 'secondary'
  }, text), /*#__PURE__*/React.createElement(ExpandMoreIcon, {
    sx: {
      color: (iconProps === null || iconProps === void 0 ? void 0 : iconProps.color) || 'secondary '
    },
    fontSize: "large"
  })), /*#__PURE__*/React.createElement(Menu, _extends({
    anchorEl: anchorEl,
    open: isOpen,
    onClick: handleClose,
    PaperProps: {
      elevation: 0,
      sx: {
        background: theme.palette.nestedSubmenu.primary,
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        mt: 1.5,
        '& .MuiAvatar-root': {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1
        },
        pt: 1,
        px: 2
      }
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }, args), children));
});
BrandDropdown.displayName = 'BrandDropdown';
var StyledDropdownItem = styled(MenuItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 10px 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n"])));

/**
 * Sub-component of `BrandDropdown` to provide abstraction for dropdown menu items.
 *
 * Icon's are optional. If nothing is specified, no element will be rendered in their place.
 *
 * @param text: `String` that will be the menu item's inner text.
 * @param leftIcon: MUI Icon element that will appear to the left the menu item's text.
 * @param rightIcon: MUI Icon element that will appear to the right the menu item's text.
 * @param onClick: Callback function to be invoked when the menu item is clicked.
 * @param args: Any arguments that should be passed through to the inner MUI `Grid` component.
 * @returns {JSX.Element}
 */
var BrandDropdownItem = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var args = _ref2.args,
    text = _ref2.text,
    leftIcon = _ref2.leftIcon,
    rightIcon = _ref2.rightIcon,
    onClick = _ref2.onClick,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  return /*#__PURE__*/React.createElement(Grid, _extends({}, args, {
    ref: ref,
    container: true,
    sx: {
      position: 'relative'
    }
  }), children || /*#__PURE__*/React.createElement(StyledDropdownItem, _extends({
    onClick: handleClick
  }, props), leftIcon && /*#__PURE__*/React.createElement(Icon, {
    sx: {
      mr: 1
    }
  }, leftIcon), text && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, text), rightIcon && /*#__PURE__*/React.createElement(Icon, {
    sx: {
      ml: 'auto'
    }
  }, rightIcon)));
});
BrandDropdownItem.displayName = 'BrandDropdownItem';

/**
 * Sub-component of `BrandDropdown` to provide grouping for dropdown menu items.
 * Default border will be `1px solid <MUI custom theme palette grey[300] -> #e0e0e0>`
 *
 * @param borderTop: `Boolean` that indicates if section should have top border.
 * @param borderBottom `Boolean` that indicates if section should have bottom border.
 * @param args Any arguments that should be passed through to the inner MUI `Box` component.
 * @returns {JSX.Element}
 */
var BrandDropdownSection = function BrandDropdownSection(_ref3) {
  var borderTop = _ref3.borderTop,
    borderBottom = _ref3.borderBottom,
    args = _ref3.args,
    children = _ref3.children;
  var theme = useTheme();
  var borderStyle = "1px solid ".concat(theme.palette.grey[300]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, args, {
    sx: {
      borderTop: borderTop && borderStyle,
      borderBottom: borderBottom && borderStyle
    }
  }), children);
};

// BrandDropdownSection.displayName = 'BrandDropdownSection';

export { BrandDropdownSection, BrandDropdownItem };
export default BrandDropdown;